export const OTHER_MEDICATIONS_OTHERS = 'af2a14fb-ffa9-4583-86b2-da6e48f8f393';
